import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const PARAGRAPH_CENTERED_ACTIVITY_FRAGMENT = gql `
  fragment ParagraphCenteredActivityFragment on ParagraphCenteredActivity {
    rounds {
      steps {
        answer
        answerImage {
          image {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default PARAGRAPH_CENTERED_ACTIVITY_FRAGMENT;
